import React, { useState, useEffect, useMemo } from 'react';
import {
  Form,
  Row,
  Col,
  Spin,
  Card,
  Input,
  Button,
  DatePicker,
} from 'antd';
import CustomTable from 'components/Table';
import NumericInput from 'components/NumericInput';
import FormSubmitControls from 'components/FormSubmitControls';
import { getMovimientosDeDeposito } from 'api/recaudacion';
import currencyFormatter from 'utils/toCurrency';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import { getModelPermission } from 'utils/permission';

export const permissionConfig = {
  model: 'movimientodepositodegarantia',
  catalogsModels: ['usuario'],
};

// eslint-disable-next-line react/prop-types
const MovimientosDeDepositos = ({ depositoID }) => {
  const permission = useMemo(
    () => getModelPermission(
      permissionConfig.model,
      permissionConfig.catalogsModels,
    ),
    [],
  );
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [visible, setVisible] = useState(false);

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
    setSelectedRowKeys([]);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [_data] = await Promise.all([
        getMovimientosDeDeposito({ deposito_en_garantia: depositoID }),
      ]);
      if (mounted) {
        setData(_data);
        setLoading(false);
      }
    };
    if (depositoID) {
      fetchAll();
    }
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      titleText: 'Usuario Que Emitió',
      dataIndex: 'usuario_que_emitio',
      key: 'usuario_que_emitio',
      width: 300,
    },
    {
      titleText: 'Importe',
      dataIndex: 'importe_de_deposito',
      key: 'importe_de_deposito',
      width: 150,
      render: (val) => currencyFormatter(val || 0),
      align: 'right',
    },
  ];

  const handleOnRowClick = (record) => setSelectedRowKeys([record.id]);

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!visible && (
          <CustomTable
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            mobileColIndex={0}
            rowKey="id"
            noControls
            disabled
            handleOnRowClick={handleOnRowClick}
            permission={permission}
          />
        )}
        {visible && (
          <Card
            className="form-container"
            bordered={false}
            title={(
              <FormSubmitControls
                label="Vista previa"
                onCancel={onCancel}
                permission={permission}
              />
            )}
          >
            <Form
              form={form}
              layout="vertical"
              name="general"
              scrollToFirstError
              className="without-feedback"
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="folio_del_deposito"
                    label="Folio de depósito"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="folio_de_recibo_de_pago"
                    label="Folio de Reciibo"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="nombre_de_beneficiario"
                    label="Nombre del beneficiario"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="nombre_del_usuario_que_emitio"
                    label="Usuario que Emitió"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="fecha_de_pago"
                    label="Fecha de Pago"
                  >
                    <DatePicker
                      format={DATE_FRONTEND_FORMAT}
                      placeholder=""
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <NumericInput
                    name="importe"
                    label="Importe"
                    decimal
                    disabled
                  />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <NumericInput
                    name="importe_pagado_del_deposito_general"
                    label="Importe Pagado"
                    decimal
                    disabled
                  />
                </Col>
                <Col xs={24} sm={24} md={16}>
                  <Form.Item
                    name="observaciones"
                    label="Observaciones"
                  >
                    <Input.TextArea
                      disabled
                      minLength={10}
                      autoSize={{ minRows: 4, maxRows: 4 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Card>
        )}
      </Spin>
    </Row>
  );
};

export default MovimientosDeDepositos;
